import React from "react";
import { CtaButton } from "../CtaButton";
import { CheckIcon } from "lucide-react";
interface Plan {
  emoji: string;
  name: string;
  featured?: boolean;
  includes: string;
  idealFor: string;
  oldPrice: string;
  price: string;
  cta: string;
  href: string;
}
const PLANS: Plan[] = [{
  emoji: "🍕",
  name: "MEGAPACK 72HS™",
  includes: "6 Tomos + 6 Bonos",
  idealFor: "Quien quiere empezar a vender comida desde casa esta semana",
  oldPrice: "$65.000",
  price: "$19.999 ARS",
  cta: "→ Quiero mi Megapack 72HS",
  href: "https://advanceformuladigital.com/products/megapack-72hs-tu-negocio-de-comidas-listo-hoy"
}, {
  emoji: "👨‍🍳",
  name: "MEGAPACK 72HS™ MAESTRO PRO",
  featured: true,
  includes: "6 Tomos + 6 Bonos + Kit Escalamiento y Marca Personal",
  idealFor: "Quien quiere construir una marca real, crecer con sistema y escalar el negocio",
  oldPrice: "$85.000",
  price: "$27.500 ARS",
  cta: "→ Quiero el Megapack Maestro PRO",
  href: "https://advanceformuladigital.com/products/megapack-72hs-tu-negocio-de-comidas-listo-hoy-pro"
}];
export function Pricing() {
  return <section id="planes" className="bg-neutral-950 py-16 px-4 border-t border-neutral-900 scroll-mt-4" data-id="element-188" data-mp="16hxad8wd6uw2">
      <div className="max-w-5xl mx-auto" data-id="element-189" data-mp="11ikn4n1kzlsy">
        <h2 className="font-display text-4xl sm:text-6xl text-white text-center uppercase mb-10" data-id="element-190" data-mp="xk4tw1ewph73">
          Elegí tu <span className="text-[#e10600]" data-id="element-191" data-mp="1u8jg2tiwc32w">Megapack</span>
        </h2>

        <div className="grid gap-6 md:grid-cols-2 items-start" data-id="element-192" data-mp="1parf7a09x6mk">
          {PLANS.map(p => <div key={p.name} className={`relative rounded-2xl p-7 flex flex-col ${p.featured ? "bg-black border-2 border-[#e10600] glow-red" : "bg-black border border-neutral-800"}`} data-id="element-193" data-mp="1l8o08beebjwj">
              {p.featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#e10600] text-white font-condensed tracking-widest text-sm px-4 py-1 rounded-full" data-id="element-194" data-mp="4tmqt0e6nfto">
                  ⭐ MÁS ELEGIDO
                </span>}
              <div className="text-4xl mb-2" data-id="element-195" data-mp="ba50vneyppq0">{p.emoji}</div>
              <h3 className="font-display text-2xl text-white uppercase leading-none" data-id="element-196" data-mp="3thaypzxgu8yu">{p.name}</h3>
              <p className="font-condensed text-lg text-[#e10600] tracking-wide mt-2" data-id="element-197" data-mp="1bz23eogczpd">{p.includes}</p>

              <div className="mt-4 flex items-start gap-2 text-sm text-neutral-400" data-id="element-198" data-mp="3jposyj3wd23h">
                <CheckIcon className="w-4 h-4 text-[#e10600] mt-0.5 flex-shrink-0" data-id="element-199" data-mp="3ohyb3cyrsxv7" />
                <span data-id="element-200" data-mp="39stws6v3jdsd"><strong className="text-neutral-300" data-id="element-201" data-mp="39t28vwjeaf2i">Ideal para:</strong> {p.idealFor}</span>
              </div>

              <div className="mt-6" data-id="element-202" data-mp="3eqvf2pkp792s">
                <span className="text-neutral-500 line-through text-xl" data-id="element-203" data-mp="3erwqiv5mlxl1">{p.oldPrice}</span>
                <div className="font-display text-5xl text-white mt-1" data-id="element-204" data-mp="30sdswwafy4mz">{p.price}</div>
              </div>

              <div className="mt-6 mt-auto pt-6" data-id="element-205" data-mp="35q5k1o39hmq4">
                <CtaButton href={p.href} variant={p.featured ? "primary" : "dark"} pulse={p.featured} data-id="element-206" data-mp="2m4n9s1l3xwn9">
                  {p.cta}
                </CtaButton>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}